import {Modal} from 'flowbite'

// import {initTE, Modal, Ripple, Select} from "tw-elements";

// if (typeof $.fn.modal !== 'undefined') {
//     //fix pro b4 a b5
//     $.fn.modal.Constructor.prototype._enforceFocus = function () {
//         let modal_this = this;
//         $(document).off('focusin.bs.modal');
//         $(document).on('focusin.bs.modal', function (e) {
//             if (modal_this._element !== e.target
//                 && $(modal_this._element).has(e.target).length === 0
//                 // add whatever conditions you need here:
//                 && !$(e.target.parentNode).hasClass('form-control')
//                 && !$(e.target.parentNode).hasClass('select2-search__field')
//                 && !$(e.target.parentNode).hasClass('select2-search')
//                 && !$(e.target.parentNode).hasClass('select2-dropdown')
//                 && !$(e.target.parentNode).hasClass('select2-container')
//                 && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_textarea')
//                 && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select')
//                 && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text')
//                 // && !$(e.relatedTarget).hasClass('ck-input-text')
//                 && !$(e.target).hasClass('ck-input-text')
//             ) {
//                 modal_this._element.focus();
//             }
//         });
//     };
//     //@todo: dohledat pro B5
// }


// $(document).ready(function () {
//
//
//
//     $(document)
//         .off('click.coc', '.click-on-class')
//         .on('click.coc', '.click-on-class', function (/*event*/) {
//             // event.preventDefault();
//             let $el = $(this);
//             if ($el.data('target') !== undefined) {
//                 let $clickable = document.getElementsByClassName($el.data('target'))[0];
//                 if ($clickable !== undefined) {
//                     $clickable.click();
//                 }
//             }
//             return false;
//         });
//
//
//     $(document).on("change", ".has-input-filter", function (/*event*/) {
//         let form = $(this).closest("form");
//         let link = $(this).data("link");
//
//         let formData = form.serializeArray();
//
//         let toSerialize = {};
//
//         for (let i = 0; i < formData.length; i++) {
//             let datum = formData[i];
//             if (datum.name !== 'do' && datum.name !== '_do') {
//                 toSerialize[datum.name] = datum.value;
//             }
//         }
//
//         naja.makeRequest('POST', link, toSerialize).then(() => {
//
//         });
//
//         return false;
//     });
//
// });


class S84FormButtonsExtension {
    constructor() {
        this.interactedElement = null;
        this.dummyElement = null;
        this.blockCloseModal = false;
    }

    initialize(naja) {
        this.naja = naja;
        // this.initBsModalFocus();

        // initTE({Modal, Ripple, Select});

        naja.addEventListener('init', this.processInit.bind(this));
        naja.uiHandler.addEventListener('interaction', this.processInteraction.bind(this));
        naja.addEventListener('before', this.processBefore.bind(this));
        naja.addEventListener('complete', this.processComplete.bind(this));
    }


    // initBsModalFocus() {
    //
    //     let modal = null;
    //     if (typeof bootstrap !== "undefined") {
    //         modal = bootstrap.Modal;
    //     } else if (typeof coreui !== "undefined") {
    //         modal = coreui.Modal;
    //     }
    //     // console.log(modal);
    //     modal._enforceFocus = function () {
    //         EventHandler.off(document, EVENT_FOCUSIN) // guard against infinite focus loop
    //         EventHandler.on(document, EVENT_FOCUSIN, event => {
    //             console.log(event);
    //             if (document !== event.target &&
    //                 this._element !== event.target &&
    //                 !this._element.contains(event.target)
    //                 && !(event.target).classList.contains('ck-input-text')
    //             ) {
    //                 this._element.focus()
    //             }
    //         })
    //     }
    // }

    processInit(/*evt*/) {
        this.editModal();
        this.inputFilterFormClick();
        this.delayedKeyUp();
        this.inputFilterChange();
        this.commonConfirm()

        const naja = this.naja;
        document.addEventListener('click', (e) => {
            if (e.target.tagName === 'A' && e.target.classList.contains('offer-ajax')) {
                e.preventDefault();
                naja.makeRequest('GET', e.target.getAttribute('href'), null, {
                    history: false
                });
                return false;
            } else if (e.target.parentNode && e.target.parentNode.tagName === 'A' && e.target.parentNode.classList.contains('offer-ajax')) {
                e.preventDefault();
                naja.makeRequest('GET', e.target.parentNode.getAttribute('href'),
                    null,
                    {
                        history: false
                    });
                return false;
            }
        });

    }

    processInteraction(evt) {
        //let $el = $(evt.detail.element);
        let el = evt.detail.element;
        this.interactedElement = el;
        if (el.classList.contains('control-cancel')) {
            evt.preventDefault();
            let closestModal = el.closest('.modal');
            if (null !== closestModal) {
                let mx = FlowbiteInstances.getInstance('Modal', closestModal.id);
                mx.hide();
            }

        } else if (el.hasAttribute("data-confirm")) {
            //potvrzení ajax smazání.
            evt.detail.options.history = false;
            if (!confirm(el.getAttribute("data-confirm"))) {
                evt.preventDefault();
            }
        }
    }

    processBefore(evt) {
        let options = evt.detail.options;
        let el = null;

        if (options.hasOwnProperty('nette') && options.nette.hasOwnProperty('el') && options.nette.el.length > 0 && null === this.interactedElement) {
            el = options.nette.el[0];
        } else if (null !== this.interactedElement) {
            el = this.interactedElement;
        }
        if (el !== null) {
            if (el.classList.contains('control-submit')) {
                el.disabled = 'disabled';
                if (!this.blockCloseModal) {
                    this.closeModal(el);
                } else {
                    this.blockCloseModal = false;
                }
                // $(el).closest("form").find(".uploader").html("");

                // this.applyOverlays(el);

            } else if (el.classList.contains('control-submit-inline-fa')) {
                el.disabled = 'disabled';
                let ds = el.dataset;
                //this.applyOverlays(el);
                if (ds.hasOwnProperty('sendingText') && ds.sendingText !== undefined) {
                    if (el.tagName === 'BUTTON') {
                        el.innerHTML = ds.sendingText;
                    } else {
                        let before = document.createElement('span');
                        before.classList.add('btn')
                        before.innerHTML = ds.sendingText;
                        if (ds.hasOwnProperty('sendingClass')) {
                            let classes = ds.sendingClass.split(' ');
                            for (let ci in classes) {
                                if (classes.hasOwnProperty(ci)) {
                                    before.classList.add(classes[ci]);
                                }
                            }
                            // before.classList.add(ds.sendingClass);
                        }
                        el.parentNode.insertBefore(before, el);
                        el.classList.add('!hidden');
                        this.dummyElement = before;
                    }
                }
            } else if (el.classList.contains('control-submit-inline')) {
                el.disabled = 'disabled';
            }
        }
        this.editModal()
        this.inputFilterFormClick()
        document.body.classList.remove('s84-has-overlay')

    }

    processComplete(evt) {
        let elements = document.querySelectorAll('[data-te-select-init]');
        elements.forEach(function (elX) {
            Select.getOrCreateInstance(elX);
        })

        let el = null;
        let payload = evt.detail.payload;
        let options = evt.detail.options;
        if (options.hasOwnProperty('nette') && options.nette.hasOwnProperty('el') && options.nette.el.length > 0 && null === this.interactedElement) {
            el = options.nette.el;
        } else if (null !== this.interactedElement) {
            el = this.interactedElement;
            this.interactedElement = null;
        }
        if (el !== null) {
            if (payload && payload.hasOwnProperty('closeModal')) {
                if (payload.closeModal === true) {
                    this.closeModal(el);
                }
            }
            if (el.classList.contains('!hidden')) {
                el.disabled = null;
                el.classList.remove('!hidden');
                if (null !== this.dummyElement) {
                    this.dummyElement.parentNode.removeChild(this.dummyElement);
                }
            }
            // this.applyOverlays(el, false);
        }

        if (payload && payload.hasOwnProperty('saveHistory')) {

            if (payload.saveHistory === true) {
                let newParams = payload.state;
                this.delete_null_properties(newParams, true);

                function isEmpty(obj) {
                    return Object.keys(obj).length === 0;
                }

                let queryString = isEmpty(newParams)
                    ? window.location.pathname
                    : window.location.pathname + '?' + (new URLSearchParams(Object.entries(newParams))).toString();

                window.history.pushState(newParams, "innoGlobalHistory", queryString);


            }
        }

        if (payload && payload.hasOwnProperty('afterComplete')) {
            let Fx = new Function(payload.afterComplete);
            Fx();
        }

        if (payload && payload.hasOwnProperty('openModalDialog')) {
            this.openModal(payload.openModalDialog);
        }

        if (payload && payload.hasOwnProperty('scrollToElement')) {
            let el = $(payload.scrollToElement);
            if (el.length > 0) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: el.offset().top
                }, 1000);
            }
        }
        if (payload && payload.hasOwnProperty('metaDescription')) {
            document.querySelector('meta[name="description"]').content = payload.metaDescription;
        }
        this.dummyElement = null;

        this.editModal();
        this.inputFilterFormClick()
        this.delayedKeyUp()
        this.inputFilterChange()
        // this.delayedKeyUp()
        // this.sendOnClick()
        this.commonConfirm();

        document.body.classList.remove('s84-has-overlay')

        let closeModalElements = document.querySelectorAll('.modal [data-te-modal-dismiss]');
        closeModalElements.forEach((closeElement) => {
            closeElement.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.closeModal(e.currentTarget);
            })
        });

    }

    /**
     * Vymaže null hodnoty
     * @param test
     * @param recurse
     */
    delete_null_properties(test, recurse) {
        for (let i in test) {
            if (test.hasOwnProperty(i)) {
                if (test[i] === null) {
                    delete test[i];
                } else if (recurse && typeof test[i] === 'object') {
                    this.delete_null_properties(test[i], recurse);
                }
            }
        }
    }

    editModal() {

        const naja = this.naja;
        const that = this;
        let handler = function (event) {
            const element = event.currentTarget;

            if (element.tagName === 'A') {
                const modalSelector = element.dataset.modalOpen;
                if (undefined === modalSelector || modalSelector.length < 1) {
                    alert("Nebyl nastaven dialog!");
                } else {
                    naja.makeRequest('GET', element.href, null, {
                        history: false
                    })
                        .then((payload) => {
                            if (payload.hasOwnProperty('skipModal') && payload.skipModal === true) {
                                //Storno otevření modal-u
                                return;
                            }

                            that.openModal(modalSelector)
                        });
                }

                event.preventDefault();
                event.stopImmediatePropagation();
            }

        }

        const elements = document.querySelectorAll('a.edit-modal');

        for (let i in elements) {
            if (elements.hasOwnProperty(i)) {
                elements[i].removeEventListener('click', handler);
                elements[i].addEventListener('click', handler, false);
            }
        }
    }


    openModal(modalSelector) {
        const that = this
        if (typeof Modal !== "undefined") {
            let element = document.getElementById(modalSelector)
            let mx = new Modal(element, {
                backdrop: 'static',
            }, {
                id: modalSelector,
                override: true,
            });
            // let mx = new Modal(element, {
            //   backdrop: 'static'
            // }, {
            //   id: modalSelector,
            // });
            mx.show();
            let elements = element.querySelectorAll('[data-s84-modal-dismiss]');
            elements.forEach((closeElement) => {
                closeElement.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    that.closeModal(e.currentTarget);
                })
            });
        }
    }

    closeModal(el) {
        let modalEl = el.closest('.modal');
        if (modalEl !== undefined && modalEl !== null) {
            if (typeof FlowbiteInstances !== "undefined") {
                let mx = FlowbiteInstances.getInstance('Modal', modalEl.id);
                mx.hide();
            }
        }
    }

    inputFilterFormClick() {
        const elements = document.querySelectorAll('.input-filter-form-click');
        const that = this;

        for (let i in elements) {
            if (elements.hasOwnProperty(i)) {
                let el = elements[i];
                if (el.dataset.link !== undefined && el.dataset.link !== null) {
                    el.addEventListener('click', function (event) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        const forceRedirect = event.currentTarget.dataset.najaForceRedirect === 'true'

                        if (event.currentTarget.dataset.confirm !== undefined) {
                            let result = confirm(event.currentTarget.dataset.confirm);
                            if (!result) {
                                return false;
                            }
                        }


                        let form = el.closest('form');
                        let link = el.dataset.link;
                        if (null !== link && link !== undefined) {
                            if (el.tagName === 'BUTTON') {
                                if (el.dataset.spinner === 'replace') {
                                    el.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
                                } else {
                                    el.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> ' + el.innerHTML;
                                }

                            }
                            that.sendFormData(form, link, false, true, false, forceRedirect);
                        }
                    });
                }
            }
        }
    }

    inputFilterChange() {
        const elements = document.querySelectorAll('.input-filter-change');
        const that = this;

        for (let i in elements) {
            if (elements.hasOwnProperty(i)) {
                let el = elements[i];
                if (el.dataset.link !== undefined && el.dataset.link !== null) {
                    el.addEventListener('change', function (event) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        const forceRedirect = event.currentTarget.dataset.najaForceRedirect === 'true'

                        let form = el.closest('form');
                        let link = el.dataset.link;
                        if (null !== link && link !== undefined) {
                            that.sendFormData(form, link, false, true, false, forceRedirect);
                        }
                    });
                }
            }
        }
    }

    delayedKeyUp() {
        const elements = document.querySelectorAll('.has-input-filter-delayed-keyup');
        const that = this;

        function delay(callback, delayInMs) {
            let timer = 0;
            return () => {
                let context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, delayInMs || 100);
            };
        }

        for (let i in elements) {
            if (elements.hasOwnProperty(i)) {
                let el = elements[i];
                if (el.dataset.link !== undefined && el.dataset.link !== null) {
                    // el.addEventListener('keyup', delay(function () {
                    if (el.dataset.s84delayedKeyUpInit !== 'yes') {
                        el.dataset.s84delayedKeyUpInit = 'yes'
                        el.addEventListener('input', delay(() => {
                            let form = el.closest('form');
                            let link = el.dataset.link;
                            if (null !== link && link !== undefined) {
                                that.sendFormData(form, link);
                            }
                        }, 250));
                    }
                }
            }
        }
    }


    sendFormData(form, link, najaHistory, blockCloseModal, unique, forceRedirect) {
        najaHistory = najaHistory !== undefined ? najaHistory : false;
        this.blockCloseModal = blockCloseModal !== undefined ? blockCloseModal : false;
        let formData = this.serializeData(new FormData(form));
        // unique = unique !== undefined ? unique : true
        forceRedirect = forceRedirect !== undefined ? forceRedirect : false

        let that = this;
        this.naja.makeRequest('POST', link, formData, {
            history: najaHistory,
            forceRedirect: forceRedirect
            // unique: unique,
        }).then(() => {
            that.blockCloseModal = false;
        });
    }

    serializeData(data) {
        let obj = {};
        for (let [key, value] of data) {
            if (key !== 'do' && key !== '_do') {
                if (key.includes("[]")) {
                    let x = key
                    key = x.replace("[]", "");
                }

                if (obj[key] !== undefined) {
                    if (!Array.isArray(obj[key])) {
                        obj[key] = [obj[key]];
                    }
                    obj[key].push(value);
                } else {
                    obj[key] = value;
                }
            }
        }
        return obj;
    }

    commonConfirm() {
        const elements = document.querySelectorAll(':not(.ajax)[data-confirm]');

        for (let i in elements) {
            if (elements.hasOwnProperty(i)) {

                if (elements[i].dataset.s84FormButtonsCommonClick !== "on") {

                    elements[i].dataset.s84FormButtonsCommonClick = "on"
                    elements[i].addEventListener('click', (e) => {
                        if (!window.confirm(e.currentTarget.getAttribute('data-confirm'))) {
                            e.preventDefault();
                        }
                    });
                }


            }
        }


        // && !window.confirm(event.detail.element.getAttribute('data-confirm'))) {
        //         event.preventDefault()
    }

}

export default S84FormButtonsExtension;

// if (typeof naja !== "undefined") {
//     naja.registerExtension(new S84FormButtonsExtension());
// }
